import Component from '@glimmer/component';
import { htmlSafe } from '@ember/template';

export interface HeroIconSignature {
  // The arguments accepted by the component
  Args: {
    icon: string;
    class?: string;
  };
  // Any blocks yielded by the component
  Blocks: {
    default: [];
  };
  // The element to which `...attributes` is applied in the component template
  Element: HTMLSpanElement;
}
import XMark from 'heroicons/24/outline/x-mark.svg?raw';
import Bell from 'heroicons/24/outline/bell.svg?raw';
import Bars3 from 'heroicons/24/outline/bars-3.svg?raw';
import Check from 'heroicons/24/outline/check.svg?raw';
import Clipboard from 'heroicons/24/outline/clipboard.svg?raw';
import ChevronDown from 'heroicons/24/outline/chevron-down.svg?raw';
import CurrencyEuro from 'heroicons/24/outline/currency-euro.svg?raw';
import ChevronUp from 'heroicons/24/outline/chevron-up.svg?raw';
import BuildingOffice from 'heroicons/24/outline/building-office.svg?raw';
import ArchiveBox from 'heroicons/24/outline/archive-box.svg?raw';
import ArrowTopRightOnSquare from 'heroicons/24/outline/arrow-top-right-on-square.svg?raw';
import CheckCircle from 'heroicons/24/outline/check-circle.svg?raw';
import ExclamationCircle from 'heroicons/24/outline/exclamation-circle.svg?raw';
import ExclamationTriangle from 'heroicons/24/outline/exclamation-triangle.svg?raw';
import InformationCircle from 'heroicons/24/outline/information-circle.svg?raw';
import XCircle from 'heroicons/24/outline/x-circle.svg?raw';

export default class HeroIconComponent extends Component<HeroIconSignature> {
  get src() {
    switch (this.args.icon) {
      case 'x-mark':
        return XMark;
      case 'bell':
        return Bell;
      case 'bars-3':
        return Bars3;
      case 'check':
        return Check;
      case 'clipboard':
        return Clipboard;
      case 'chevron-down':
        return ChevronDown;
      case 'currency-euro':
        return CurrencyEuro;
      case 'chevron-up':
        return ChevronUp;
      case 'building-office':
        return BuildingOffice;
      case 'arrow-top-right-on-square':
        return ArrowTopRightOnSquare;
      case 'check-circle':
        return CheckCircle;
      case 'exclamation-circle':
        return ExclamationCircle;
      case 'exclamation-triangle':
        return ExclamationTriangle;
      case 'information-circle':
        return InformationCircle;
      case 'x-circle':
        return XCircle;
      case 'archive-box':
        return ArchiveBox;

      default:
        console.warn('HeroIcon: Unknown icon ', this.args.icon);
        break;
    }
    return '';
  }
  <template>
    <span ...attributes>
      {{htmlSafe this.src}}
    </span>
  </template>
}
